Q     = require('q')
axios = require('axios')

module.exports = require('frontend/components/abstract').extend

  template: require('./index.pug')

  components:
    'prevented-form':     require('../prevented_form')
    'loading-indicator':  require('../loading_indicator')

  data: ->
    email:    null
    password: null
    error:    null

  methods:

    resetDataToDefaults: ->
      @.$set(@, 'email', null)
      @.$set(@, 'password', null)
      @.$set(@, 'error', null)

    getCsrfToken: ->
      document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    pressSubmit: ->
      @.$refs.form.submit()

    showLoadingIndicator: ->
      @.$refs.loadingIndicator.show()

    hideLoadingIndicator: ->
      @.$refs.loadingIndicator.hide()

    submit: ->
      @showLoadingIndicator()

      signInData = {
        method:   'post'
        url:      '/account/sign_in.json'
        data:     { school_user: { email: @email, password: @password } }
        headers:  { 'X-CSRF-Token': @getCsrfToken() }
      }

      errorFunc = (error) =>
        window.error = error
        if error.response?.data?
          @.$set @, 'error', error.response.data.error
        else
          @.$set @, 'error', 'Fehler bei der Anmeldung'

        @hideLoadingIndicator()

      axios(signInData)
      .then (response) =>
        # window.location.pathname = response.headers?.location || '/account'
        window.location.pathname = '/account'
        @hideLoadingIndicator()
      .catch(errorFunc)




// WEBPACK FOOTER //
// ./assets/js/frontend/components/school_login_form/index.coffee